<form [formGroup]="form" class="d-flex flex-column">
  <div class="form-group row">
    <mat-form-field class="col mt-2" appearance="outline">
      <mat-label>Comune</mat-label>
      <mat-select
        #comuniSelect
        formControlName="istatComune"
        multiple
        (openedChange)="onComuniPanelOpenedChange($event, comuniSelect)"
        (selectionChange)="filtroComuni = ''"
      >
        <div class="filtro-opzioni" *ngIf="opzioniComune.length" (click)="$event.stopPropagation()">
          <input
            type="text"
            placeholder="Cerca comune..."
            [(ngModel)]="filtroComuni"
            [ngModelOptions]="{ standalone: true }"
            (keydown)="$event.stopPropagation()"
          />
        </div>
        <mat-option *ngIf="!opzioniComune.length" disabled class="no-options-placeholder">Nessun comune disponibile</mat-option>
        <mat-option *ngIf="opzioniComune.length && !opzioniComuneFiltrate.length" disabled class="no-options-placeholder">Nessun comune trovato</mat-option>
        <mat-option *ngFor="let opzione of opzioniComune" [value]="opzione.codice" [class.d-none]="!comuneCorrisponde(opzione)">{{ opzione.nome || ('Comune non censito (codice ' + opzione.codice + ')') }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="form-group row">
    <div class="col mt-2 d-flex align-items-center justify-content-between">
      <button mat-stroked-button type="button" *ngIf="!poligonoAttivo" (click)="disegnaPoligono.emit()">Disegna area sulla mappa</button>
      <button mat-stroked-button type="button" *ngIf="poligonoAttivo" (click)="rimuoviPoligono.emit()">Rimuovi area disegnata</button>
      <button mat-icon-button type="button" matTooltip="Legenda colori" (click)="onApriLegenda()">
        <mat-icon>palette</mat-icon>
      </button>
    </div>
  </div>

  <div class="form-group row">
    <mat-form-field class="col mt-2" appearance="outline">
      <mat-label>Tipologia punto</mat-label>
      <mat-select
        #tipologieSelect
        formControlName="tipoPuntoCampionamento"
        multiple
        (openedChange)="onTipologiePanelOpenedChange($event, tipologieSelect)"
        (selectionChange)="filtroTipologie = ''"
      >
        <div class="filtro-opzioni" (click)="$event.stopPropagation()">
          <input
            type="text"
            placeholder="Cerca tipologia..."
            [(ngModel)]="filtroTipologie"
            [ngModelOptions]="{ standalone: true }"
            (keydown)="$event.stopPropagation()"
          />
        </div>
        <mat-option *ngIf="!opzioniTipologiaFiltrate.length" disabled class="no-options-placeholder">Nessuna tipologia trovata</mat-option>
        <mat-option *ngFor="let tipo of opzioniTipologia" [value]="tipo.codice" [class.d-none]="!tipologiaCorrisponde(tipo)">
          <div class="d-flex flex-column align-items-start justify-content-start gap-1" [title]="tipo.codice + ' — ' + tipo.descrizione">
            <div>{{ tipo.codice }} — {{ tipo.descrizione }}</div>
            <div class="font-09rem categoria-tipo-punto">{{ nomeCategoria(tipo.categoria) }}</div>
          </div>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="form-group row" *ngIf="!mostraCriterio || criterio !== 'integrated'">
    <mat-form-field class="col mt-2" appearance="outline">
      <mat-label>Analiti</mat-label>
      <mat-select
        #analitiSelect
        formControlName="codiciParametro"
        multiple
        (openedChange)="onAnalitiPanelOpenedChange($event, analitiSelect)"
        (selectionChange)="filtroAnaliti = ''"
      >
        <div class="filtro-opzioni" (click)="$event.stopPropagation()">
          <input
            type="text"
            placeholder="Cerca analita..."
            [(ngModel)]="filtroAnaliti"
            [ngModelOptions]="{ standalone: true }"
            (keydown)="$event.stopPropagation()"
          />
        </div>
        <mat-option *ngIf="!opzioniAnalitiFiltrate.length" disabled class="no-options-placeholder">Nessun analita trovato</mat-option>
        <mat-option
          *ngFor="let parametro of opzioniAnaliti"
          [value]="parametro.codice"
          [class.d-none]="!analitaCorrisponde(parametro)"
          [disabled]="!parametroClassificabile(parametro)"
        >
          {{ parametro.codice | underscoreToSpace }}
          <span *ngIf="!parametroClassificabile(parametro)" class="non-classificabile">(non classificabile)</span>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <ng-container *ngIf="mostraCriterio">
    <div class="form-group row">
      <mat-form-field class="col mt-2" appearance="outline">
        <mat-label>Criterio di colorazione</mat-label>
        <mat-select formControlName="criterio">
          <mat-option value="last">Ultimo controllo</mat-option>
          <mat-option value="q95">95° percentile</mat-option>
          <mat-option value="integrated">Integrato</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="form-group row" *ngIf="criterio === 'integrated'">
      <div class="col nota-criterio">
        <mat-icon>info_outline</mat-icon>
        <span>
          L'indice integrato combina il valore di rischio attuale della MdR con quello del rischio analitico, calcolato considerando la
          classe di rischio peggiore tra quelle dei 95° percentili riferiti all'anno corrente ({{ annoCorrente - 3 }}-{{ annoCorrente - 1 }})
          di tutti gli analiti a disposizione per il punto di campionamento.
        </span>
      </div>
    </div>

    <div class="form-group row" *ngIf="criterio === 'last'">
      <mat-form-field class="col mt-2" appearance="outline">
        <mat-label>Da</mat-label>
        <input formControlName="dataInizio" [matDatepicker]="pickerInizio" matInput />
        <mat-datepicker-toggle [for]="pickerInizio" matSuffix></mat-datepicker-toggle>
        <mat-datepicker #pickerInizio></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="form-group row" *ngIf="criterio === 'last'">
      <mat-form-field class="col mt-2" appearance="outline">
        <mat-label>A</mat-label>
        <input formControlName="dataFine" [matDatepicker]="pickerFine" matInput />
        <mat-datepicker-toggle [for]="pickerFine" matSuffix></mat-datepicker-toggle>
        <mat-datepicker #pickerFine></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="form-group row" *ngIf="criterio === 'q95'">
      <mat-form-field class="col mt-2" appearance="outline">
        <mat-label>Anno di riferimento</mat-label>
        <mat-select formControlName="annoRiferimento">
          <mat-option *ngFor="let anno of anniDisponibili" [value]="anno">{{ anno }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="form-group row" *ngIf="criterio === 'q95'">
      <div class="col nota-criterio">
        <mat-icon>info_outline</mat-icon>
        <span>
          L'indicatore selezionato è il 95° percentile, in questo caso si considerano i dati relativi ai 3 anni solari precedenti
          all'anno di riferimento specificato, se disponibili.
          <ng-container *ngIf="annoRiferimento">
            Per il {{ annoRiferimento }} si considerano i prelievi del {{ annoRiferimento - 3 }}–{{ annoRiferimento - 1 }}.
          </ng-container>
        </span>
      </div>
    </div>
  </ng-container>
</form>
<div style="display: flex; flex-direction: row">
  <div class="d-flex justify-content-start gap-3 mt-4" style="flex: 1">
    <button mat-flat-button color="primary" *ngIf="isRiepilogoOpen || criterio === 'q95'" (click)="onToggleRiepilogo()">
      {{ isRiepilogoOpen ? 'Mappa' : 'Riepilogo' }}
    </button>
  </div>
  <div class="d-flex justify-content-end gap-3 mt-4">
    <button mat-flat-button color="secondary" (click)="onReset()">Azzera</button>
    <button mat-flat-button color="primary" (click)="onApplica()">Applica</button>
  </div>
</div>
